import { useState } from 'react';
import classNames from 'classnames/bind';

import styles from './index.module.scss';
import { finances } from '../../../assets/data/finance';
import PageTitle from '../../../components/shared/PageTitle';
import ReportCommon from './ReportCommon';
import Report2021 from './Report2021';
import Report2022 from './Report2022';
import Report2023 from './Report2023';
import Report2024 from './Report2024';
import Report2025 from './Report2025';
import Announce2025 from './Announce2025';

const cx = classNames.bind(styles);

const Finance = () => {
  const [data, setData] = useState('r2025');

  const onChange = (e) => {
    const value = e.target.value;
    const year = Math.trunc(value.slice(1));

    if (year < 2021) {
      const nextData = finances.find((item) => item.year === year);
      setData(nextData);
    } else {
      setData(value);
    }
  };

  return (
    <div className={cx('container')}>
      <PageTitle title="전자공시" />
      <div className={cx('selectInner')}>
        <div className={cx('select')}>
          <select onChange={onChange}>
            <option value="r2025">2025 전자공시</option>
            <option value="a2025">2025 합병공고</option>
            <option value="r2024">2024 전자공시</option>
            <option value="r2023">2023 전자공시</option>
            <option value="r2022">2022 전자공시</option>
            <option value="r2021">2021 전자공시</option>
            <option value="r2020">2020 전자공시</option>
            <option value="r2019">2019 전자공시</option>
            <option value="r2018">2018 전자공시</option>
            <option value="r2017">2017 전자공시</option>
            <option value="r2016">2016 전자공시</option>
            <option value="r2015">2015 전자공시</option>
            <option value="r2014">2014 전자공시</option>
          </select>
        </div>
      </div>
      <div className={cx('section')}>
        {data === 'r2025' && <Report2025 />}
        {data === 'a2025' && <Announce2025 />}
        {data === 'r2024' && <Report2024 />}
        {data === 'r2023' && <Report2023 />}
        {data === 'r2022' && <Report2022 />}
        {data === 'r2021' && <Report2021 />}
        {data?.year < 2021 && <ReportCommon data={data} />}
      </div>
    </div>
  );
};

export default Finance;
